import _createForOfIteratorHelper from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "el-upload__tip"
};
import { ElNotification } from 'element-plus';
import 'element-plus/es/components/notification/style/css'

import ExcelErrorDialog from './excel/error-dialog.vue';
import XUpload from '../x-upload/XUpload.vue';

import { ref, computed, watch } from 'vue';
var KB = 1024;
export default /*@__PURE__*/_defineComponent({
  __name: 'UploadContainer',
  props: {
    action: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    autoUpload: {
      type: Boolean,
      default: false
    },
    accept: {
      type: Array,
      default: function _default() {
        return ['.xls', '.xlsx'];
      }
    },
    limit: {
      type: Number,
      default: 1
    },
    maxSize: {
      type: Number,
      default: 1024 * 1024 * 100
    },
    resultHandler: Function,
    errorHandler: Function,
    exportBaseUrl: {
      type: String,
      default: ''
    },
    beforeUpload: Function
  },
  emits: ['importStart', 'importEnd', 'importSuccess', 'importError'],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var M = KB * 1024;
    var props = __props;
    var emits = __emit;
    var upload = ref({
      fileList: [],
      uploading: false
    });
    var uploader = ref();
    var errorDialogInstance = ref();
    var getAccepts = computed(function () {
      return props.accept.length > 0 ? props.accept.join(',') : '*';
    });
    var getExtensions = computed(function () {
      return props.accept.length > 0 ? props.accept.join('、') : '*';
    });
    var getLimitation = computed(function () {
      if (props.maxSize >= 1 * M) {
        return props.maxSize / (1 * M) + 'MB';
      }
      if (props.maxSize >= 1 * KB) {
        return props.maxSize / (1 * KB) + 'KB';
      }
      return props.maxSize + 'B';
    });
    var getTip = computed(function () {
      var extensions = getExtensions.value;
      var limitation = getLimitation.value;
      if (extensions && !limitation) {
        return "\u53EF\u4EE5\u4E0A\u4F20".concat(extensions, "\u7C7B\u578B\u7684\u6587\u4EF6\u3002");
      }
      if (!extensions && limitation) {
        return "\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(limitation, "\u3002");
      }
      if (extensions && limitation) {
        return "\u53EF\u4EE5\u4E0A\u4F20".concat(extensions, "\u7C7B\u578B\u7684\u6587\u4EF6\uFF0C\u4E14\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7").concat(limitation, "\u3002");
      }
      return '';
    });
    watch(function () {
      return upload.value.uploading;
    }, function (newVal) {
      newVal ? emits('importStart') : emits('importEnd');
    });
    function submit() {
      var _uploader$value;
      (_uploader$value = uploader.value) === null || _uploader$value === void 0 || _uploader$value.submit();
    }
    function reset() {
      upload.value.fileList = [];
      upload.value.uploading = false;
    }
    function uploadCallback(promise) {
      upload.value.uploading = true;
      promise.then(function (res) {
        upload.value.uploading = false;
        if (props.resultHandler) {
          props.resultHandler(res);
          return;
        }
        var result = res.data;
        var sheetImportResults = result.sheetImportResults;
        if (sheetImportResults && sheetImportResults.length > 0) {
          var error = sheetImportResults.some(function (r) {
            return r.cellErrors && r.cellErrors.length > 0;
          });
          if (error) {
            var _errorDialogInstance$;
            emits('importError', result);
            (_errorDialogInstance$ = errorDialogInstance.value) === null || _errorDialogInstance$ === void 0 || _errorDialogInstance$.show(result);
          } else {
            emits('importSuccess', result);
          }
        } else {
          console.info(result);
          ElNotification({
            type: 'error',
            message: '导入结果异常'
          });
        }
      }).catch(function (e) {
        var _res$data;
        if (props.errorHandler) {
          props.errorHandler(e);
          return;
        }
        console.error(e);
        var res = e.response;
        ElNotification({
          type: 'error',
          message: (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.message) || '导入失败，未知的错误'
        });
      }).finally(function () {
        upload.value.uploading = false;
      });
    }
    function doBeforeUpload(files, data) {
      if (!files || files.length < 1) {
        ElNotification({
          type: 'warning',
          message: '请选择需要导入的文件'
        });
        return false;
      }
      if (props.maxSize) {
        var size = 0;
        var _iterator = _createForOfIteratorHelper(files),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var file = _step.value;
            size += file.size;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (size > props.maxSize) {
          ElNotification({
            type: 'warning',
            message: "\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(getLimitation.value)
          });
          return false;
        }
      }
      return !props.beforeUpload || !!props.beforeUpload(files, data);
    }
    function handleChange(files, fileList) {
      if (!fileList) {
        return;
      }
      if (props.limit === 1) {
        if (fileList.length > 1) {
          upload.value.fileList = fileList.slice(-1);
        }
      } else {
        if (fileList.length > props.limit) {
          ElNotification({
            type: 'warning',
            message: "\u6700\u591A\u53EA\u80FD\u4E0A\u4F20".concat(props.limit, "\u4E2A\u6587\u4EF6")
          });
          upload.value.fileList = fileList.slice(0, fileList.length - 1);
        }
      }
    }
    function handleFileModified(file) {
      ElNotification({
        type: 'warning',
        message: "\u6587\u4EF6 ".concat(file.name, " \u5DF2\u4FEE\u6539\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u6B64\u6587\u4EF6")
      });
    }
    __expose({
      submit: submit,
      reset: reset
    });
    return function (_ctx, _cache) {
      var _component_upload_filled = _resolveComponent("upload-filled");
      var _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(XUpload, {
        ref_key: "uploader",
        ref: uploader,
        class: "uploader",
        action: __props.action,
        callback: uploadCallback,
        accept: _unref(getAccepts),
        "auto-upload": __props.autoUpload,
        multiple: __props.multiple,
        value: __props.value,
        "file-list": _unref(upload).fileList,
        "on-change": handleChange,
        disabled: _unref(upload).uploading,
        "before-upload": doBeforeUpload,
        "on-modified": handleFileModified,
        limit: __props.limit
      }, {
        tip: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, _toDisplayString(_unref(getTip)), 1)];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_el_icon, {
            class: "el-icon--upload"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_upload_filled)];
            }),
            _: 1
          }), _cache[0] || (_cache[0] = _createElementVNode("div", {
            class: "el-upload__text"
          }, [_createTextVNode("将文件拖到此处，或"), _createElementVNode("em", null, "点击上传")], -1))];
        }),
        _: 1
      }, 8, ["action", "accept", "auto-upload", "multiple", "value", "file-list", "disabled", "limit"]), _createVNode(ExcelErrorDialog, {
        ref_key: "errorDialogInstance",
        ref: errorDialogInstance,
        title: "导入失败",
        width: "30%",
        exportBaseUrl: __props.exportBaseUrl,
        "append-to-body": true
      }, null, 8, ["exportBaseUrl"])]);
    };
  }
});